import { isNil } from 'lodash-es'

export const isEmptyString = (value: unknown): value is '' =>
  typeof value === 'string' && value === ''

export const isNilOrEmptyString = (
  value: unknown,
): value is null | undefined | '' => isNil(value) || isEmptyString(value)

export const isSame = (
  a: unknown,
  b: unknown,
  type: 'string' | 'number' | 'boolean',
) => {
  if (type === 'string') {
    // 둘 다 빈 값이거나 값이 있는데 같은 값이 있는 경우 true
    if (isNilOrEmptyString(a) && isNilOrEmptyString(b)) {
      return true
    }

    return a === b
  }

  if (type === 'number') {
    if (isNilOrEmptyString(a) && isNilOrEmptyString(b)) {
      return true
    }

    if (isNaN(Number(a)) || isNaN(Number(b))) {
      return false
    }

    return Number(a) === Number(b)
  }

  if (type === 'boolean') {
    if (isNilOrEmptyString(a) && isNilOrEmptyString(b)) {
      return true
    }

    return (
      Boolean(a === 'true' || a === true) ===
      Boolean(b === 'true' || b === true)
    )
  }
}
